/**
 * Utility for handling browser-based notifications for the PWA
 */
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support notifications.");
    return false;
  }

  if (Notification.permission === "granted") return true;

  const permission = await Notification.requestPermission();
  return permission === "granted";
};

export const sendNotification = (title, body, icon = 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?q=80&w=192&h=192&auto=format&fit=crop') => {
  if (Notification.permission === "granted") {
    // Attempt local notification
    try {
      const options = {
        body,
        icon,
        badge: icon,
        vibrate: [200, 100, 200],
      };

      // Try via Service Worker first (better for PWA)
      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.ready.then(registration => {
          registration.showNotification(title, options);
        });
      } else {
        new Notification(title, options);
      }
    } catch (e) {
      console.error("Notification failed", e);
    }
  }
};